export const getImageChoiceOptions = (value) => {
  let options = value;

  if (typeof options === 'string') {
    try {
      options = JSON.parse(options);
    } catch {
      return null;
    }
  }

  if (Array.isArray(options)) {
    return options;
  }

  if (
    options &&
    typeof options === 'object' &&
    Array.isArray(options.options)
  ) {
    return options.options;
  }

  return null;
};
